import Head from "next/head";
import React from "react";

const MetaHead = ({ ...props }) => {

	const prop = props;
	const data = {
		title: prop.title || "Female Daily - Beauty Review",
		description: prop.description || "Discover and give your reviews on makeup, skincare, body care, hair care, nail care, beauty and perfume products.",
		keywords: prop.keywords || "Reviews, Makeup, Skincare, Product",
		url: prop.url || process.env.NEXT_PUBLIC_ROOT_DOMAIN,
		// canonical: prop.canonical || process.env.NEXT_PUBLIC_ROOT_DOMAIN,
		author: prop.author || "Female Daily",
		publisher: prop.publisher || "Female Daily",
	};

	return (
		<Head>
			<title>
				{data.title}
			</title>

			{/* META SEO */}
			<link rel="canonical" href={data.url} />
			<meta name="description" content={data.description} />
			<meta name="author" content={data.author} />
			<meta name="publisher" content={data.publisher} />
			<meta name="keywords" content={data.keywords} />

			<meta property="og:description" content={data.description} />
			<meta property="og:url" content={data.url} />
		</Head>
	);

};

export default MetaHead;
